import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { forkJoin } from 'rxjs';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService, LanguageService } from 'vhobjects-service/src/services';

@Component({
  selector: 'app-review-config',
  templateUrl: './review-config.component.html',
  styleUrls: ['./review-config.component.scss'],
})
export class AtwReviewConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() blocks_of_page: any; // là dữ liệu blocks_of_page từ database

  isCollapsed: boolean = false;
  fonts: any[] = []; // biến lưu font chữ
  effect_hover: any[] = []
  effect_hover_data: any = {}
  customize: any; // biến lưu customize từ choose-animations-config truyền về
  public isViewAll = false; // biến xác định trạng thái mở rộng phần cấu hình
  public currentViewAll: any = {};
  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false
  };
  public bootstrapIconArrows: any = [
    {
      icon_left: 'bi bi-chevron-left',
      icon_right: 'bi bi-chevron-right',
    },
    {
      icon_left: 'bi bi-arrow-left-short',
      icon_right: 'bi bi-arrow-right-short',
    },
    {
      icon_left: 'bi bi-caret-left-fill',
      icon_right: 'bi bi-caret-right-fill',
    },
    {
      icon_left: 'bi bi-chevron-compact-left',
      icon_right: 'bi bi-chevron-compact-right',
    },
  ];
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 2,
    },
    {
      title: 'nang_cao',
      index: 3,
    }
  ];
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top,',
      name: 'tu_duoi_len_tren',
      deg: '0deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'tu_trai_tren_sang_phai_duoi',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'tu_phai_tren_sang_trai_duoi',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'tu_trai_duoi_sang_phai_tren',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'tu_phai_duoi_sang_trai_tren',
      deg: '315deg',
    },
  ];
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    private renderer: Renderer2,
    public languageService: LanguageService,
    private nzModalService: NzModalService,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService
  ) {}

  ngOnInit(): void {
    this.class = this.objectChoosing[this.device + '_class'];
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      // this.http.get('assets/data/effects/frame-collapse.json')
    ]).subscribe(
      ([fonts, effects]: any) => {
        this.fonts = fonts;
        // this.effect_hover = effects;
        // this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      }
    );
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) {
      if (this.config['type'] == 'horizontal') {
        this.class['menu']['width'] = event.width + 'px';
      } else {
        this.class['mobilemenu']['width'] = event.width + 'px';
      }
    }
    if (event.height) {
      if (this.config['type'] == 'horizontal') {
        this.class['menu']['height'] = event.height + 'px';
      } else {
        this.class['mobilemenu']['height'] = event.height + 'px';
      }
    }
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
        [this.device + '_config']: this.config,
        staticdata: this.staticdata,
      })
      .then((bool: any) => {});
  }

  /**
   * Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {});
  }

  /**
   * Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {});
  }

  /**
   * Hàm update staticdata vào database.
   */
  updateStaticdata() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      staticdata: this.staticdata,
    }).then((bool: any) => {});
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[0])
  }

  /**
   * Khi thay đổi cấu hình Giới hạn chiều cao để cuộn
   */
  updateMaxHeight() {
    if (this.config['max_height']) {
      this.class['review']['max-height'] = '200px';
      this.class['review']['overflow-y'] = 'auto';
    }
    else {
      this.class['review']['max-height'] = 'none';
      this.class['review']['overflow-y'] = 'unset';
    }
    this.updateConfig();
    this.updateClass();
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['review']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['review']['background-image'] = "none";
    }
    this.updateObject();
  }

  /**Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      // Lấy ra element màu được click từ tham số event trả về.
      var activeGradient = document.querySelector(
        '.container-color .active'
      ) as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Lấy giá trị màu được click từ tham số bgColor.
      //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
      const data_background = this.class['review']
      data_background['background-color'] = bgColor.bgColor;
      data_background['background-color'] = `rgba(${this.hexToRGB(data_background['background-color'])}, ${this.config['background-color'].value_range})`;
      this.updateObject();
    }
  }

  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Get class active của element khi click chọn hướng phối màu.
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      var activeGradient = document.querySelector('.active') as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['review']['background-image'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  /*--------- Thay đổi mũi tên điều hướng trang -------------------*/
  onChangeArrows(arrows) {
    this.config.icon_pagination.arrow_left_icon = arrows.icon_left;
    this.config.icon_pagination.arrow_right_icon = arrows.icon_right;
    this.updateConfig();
  }

  onReviewTypeChange(type: 'review' | 'comment') {
    if (type === 'review') {
      this.staticdata.review_require_login = true;
    }
    this.updateStaticdata();
  }
}
